import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [
    {path: '/',                                 name: 'Charges',              component: () => import(/* webpackChunkName: "ShiftsPage" */ '@/pages/Reports/Shifts/ShiftsPage.vue')},
    {path: '/Reports/ShiftsPage',               name: 'ShiftsPage',              component: () => import(/* webpackChunkName: "ShiftsPage" */ '@/pages/Reports/Shifts/ShiftsPage.vue')},
    {path: '/Reports/Charges',                  name: 'Charges',                 component: () => import(/* webpackChunkName: "Charges" */ '@/pages/Reports/Charges/ChargesPage.vue')},
  ]
})
